function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { rgba } from 'polished';
var colorList = {
  blue: {
    '50': '#ebf4ff',
    '100': '#d6e9ff',
    '200': '#add3ff',
    '300': '#70b3ff',
    '400': '#3392ff',
    '500': '#0072f5',
    '600': '#0056b8'
  },
  red: {
    '100': '#fbdcda',
    '200': '#f7bab6',
    '300': '#f1867e',
    '400': '#eb5247',
    '500': '#dc2518',
    '600': '#a51c12'
  },
  orange: {
    '50': '#fff3eb',
    '100': '#fee7d7',
    '200': '#fdceaf',
    '300': '#fcaa73',
    '400': '#fb8537',
    '500': '#f06305',
    '600': '#b44a04'
  },
  yellow: {
    '50': '#fff8eb',
    '100': '#fff1d6',
    '200': '#ffe4ad',
    '300': '#ffcf70',
    '400': '#ffbb33',
    '500': '#f5a300',
    '600': '#b87a00'
  },
  purple: {
    '100': '#f5d9fd',
    '200': '#ecb2fa',
    '300': '#dd79f6',
    '400': '#cf3ff3',
    '500': '#bb0fe6',
    '600': '#8c0bac'
  },
  violet: {
    '100': '#f3ebff',
    '200': '#dac2ff',
    '300': '#c299ff',
    '400': '#9147ff',
    '500': '#6200f5',
    '600': '#4900b8'
  },
  green: {
    '100': '#def8de',
    '200': '#bcf0bc',
    '300': '#8ae58a',
    '400': '#58da58',
    '500': '#2cc92c',
    '600': '#209820'
  },
  grey: {
    '50': '#f9fafb',
    '75': '#f6f7f9',
    '100': '#f3f4f6',
    '200': '#e7e9ee',
    '300': '#d0d3dd',
    '400': '#acb2c3',
    '500': '#8992a9',
    '600': '#67718e',
    '700': '#4d556a',
    '800': '#343947',
    '900': '#111318'
  }
};
var aliases = {
  black: '#000000',
  white: '#FFFFFF',
  transparent: rgba(0, 0, 0, 0)
};

var colors = _objectSpread(_objectSpread({}, colorList), aliases);

export default colors;
export { colors };